import styled from 'styled-components';
import theme from '../../../styles/defaultTheme';

export const ContainerRadio = styled.div`
    & .MuiFormControlLabel-root {
        width: ${({ columns }) => columns && `${Math.floor(100 / columns)}%`};
    }

    .MuiFormControlLabel-label {
        color: ${(props) => props.theme.black};
    }

    & .MuiTypography-root.MuiFormControlLabel-label.Mui-disabled div {
        color: ${({ contrastTheme, theme: styledTheme }) =>
            contrastTheme ? styledTheme.lightGrey20 : styledTheme.lightGreyLink40};
        cursor: not-allowed;
    }

    @media(min-width: 1024px) {
        div.MuiFormGroup-root {
            flex-direction: row;
        }
    }
`;

export const Icon = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background-color: ${(props) => (props.disabled ? props.theme.lightGrey20 : props.theme.white)};
    border: 1px solid ${(props) => (props.disabled ? props.theme.borderWhite : props.theme.lightGreyLink40)};
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
    width: 20px;
    height: 20px;

    & .Mui-focusVisible {
        outline: 2px auto rgba(19,124,189,.6);
        outline-offset: 2;
    }

    & .error {
        border: 1px solid ${(props) => props.theme.red};
    }

    & input:disabled  {
        box-shadow: none;
        background: rgba(206,217,224,.5);
    }
`;

export const CheckedIcon = styled(Icon)`
    &:before {
        border-radius: 50%;
        display: block;
        width: 12px;
        height: 12px;
        background-color: ${(props) => props.theme.orange} !important;
        content: "";
    }
`;

export const RadioText = styled.div`
    font: ${theme.font.body[1]};
    letter-spacing: 0px;
    color: ${(props) => props.theme.blackLink};
    font: inherit;
`;
